module.exports = __webpack_public_path__ + "static/img/canary.c44d3e06.webp";